export default __webpack_public_path__ + "static/day-14-8d9b2934602bff8deb8e8bc22b7d6803.gif";